import styled from 'styled-components';

import { BigButton } from '../../components/Buttons';
import BigButtonOutlined from '../../components/Buttons/BigButtonOutlined';

/**
 * Payment page styles
 * Includes shared checkout components used across payment pages:
 * - payment.tsx (regular ticket purchases)
 * - resale-payment.tsx (resale ticket purchases)
 */

// Shared checkout components
export const WrapperPayment = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #f4f6f8;
`;

export const CheckoutContainer = styled.div`
  width: 100%;
  padding-bottom: 128px;
`;

export const CheckoutFrame = styled.div`
  width: 100%;
  background-color: #f4f6f8;
  padding-bottom: 128px;
  flex: 1;
`;

export const PaymentFooter = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  padding: 1rem;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  gap: 1rem;
  box-shadow: 3px 0 5px rgba(0, 0, 0, 0.3);

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

// Payment-specific styled components
export const CustomBigButton = styled(BigButton)`
  max-width: 400px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const CustomBigButtonOutlined = styled(BigButtonOutlined)`
  max-width: 400px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const IframeErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 24px;
  gap: 16px;
`;

export const IframeErrorText = styled.p`
  text-align: center;
  font-size: 16px;
  color: #666;
  margin: 0;
`;

export const ResaleDisclaimer = styled.p`
  text-align: center;
  font-size: 12px;
  color: #888;
  margin: 0;
  max-width: 600px;
  width: 100%;
  padding: 16px 24px;
  line-height: 1.5;
  background-color: #f4f6f8;
  align-self: center;
`;
